module.exports = __webpack_public_path__ + "img/15_DSC8200-min.72397a21.jpg";